import { render, staticRenderFns } from "./ExtractionAffiliationNic.vue?vue&type=template&id=18203032"
import script from "./ExtractionAffiliationNic.vue?vue&type=script&lang=js"
export * from "./ExtractionAffiliationNic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports